import { Caption } from 'modules/design-system';
import styled from 'styled-components';

export namespace AuthBaseCardFooterCSS {
  export const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding-top: ${({ theme }) => theme.spacing.xxl};
    gap: ${({ theme }) => theme.spacing.xxl};
  `;

  export const LinkWrapper = styled(Caption)`
    align-items: center;
    display: flex;
    flex-direction: column;
  `;

  export const HibooIconWrapper = styled.span`
    color: ${({ theme }) => theme.colors.text.subtle};
    display: flex;
  `;
}
